import { render } from "./PdfCanvas.vue?vue&type=template&id=ac542e1e"
import script from "./PdfCanvas.vue?vue&type=script&lang=js"
export * from "./PdfCanvas.vue?vue&type=script&lang=js"

import "./PdfCanvas.vue?vue&type=style&index=0&id=ac542e1e&lang=less"

import exportComponent from "D:\\WorkSpace\\Codes\\website-apps\\frontend\\report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__